import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { SERVER_URL } from "./config";
import "./ShowGiftsPage.css";

const ShowGiftsPage = () => {
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");
  const api = axios.create({
    baseURL: SERVER_URL,
    headers: token ? { Authorization: `Token ${token}` } : {},
  });

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        setError("");
        const res = await api.get("api/gifts/get");
        if (!alive) return;
        setGifts(res?.data?.gifts || []);
      } catch {
        if (!alive) return;
        setError("אירעה שגיאה בטעינת המתנות");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []); 

  const fmtAmount = (n) =>
    Number(n || 0).toLocaleString("he-IL", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const totalAmount = useMemo(() => {
    return gifts.reduce((acc, g) => acc + Number(g?.amount || 0), 0);
  }, [gifts]);

  const downloadExcel = async () => {
    try {
      const res = await api.get("api/gifts/export/", { responseType: "blob" });
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "gifts.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      setError("נכשל בהורדת האקסל");
    }
  };

  return (
    <div className="gifts-container">
      <div className="gifts-header">
        <div className="gifts-actions">
          <div className="gifts-total">
            סה״כ: <span>₪{fmtAmount(totalAmount)}</span>
          </div>
          <button
            type="button"
            className="gifts-download-btn"
            onClick={downloadExcel}
            aria-label="הורד לאקסל"
            title="הורד לאקסל"
          >
            הורד לאקסל
          </button>
        </div>
      </div>

      {loading ? (
        <div className="gifts-status">טוען…</div>
      ) : error ? (
        <div className="gifts-status gifts-error">{error}</div>
      ) : gifts.length === 0 ? (
        <div className="gifts-empty">עוד לא קיבלת מתנות באשראי</div>
      ) : (
        <div className="gifts-table-wrap">
          <table className="gifts-table" dir="rtl">
            <thead>
              <tr>
                <th>שם מעניק</th>
                <th>סכום (₪)</th>
                <th>ברכה</th>
              </tr>
            </thead>
            <tbody>
              {gifts.map((g, i) => (
                <tr key={i}>
                  <td className="giver">{g?.giver_name || "-"}</td>
                  <td className="amount">₪{fmtAmount(g?.amount)}</td>
                  <td className="blessing">{g?.blessing || ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ShowGiftsPage;
